/**
 * Configuração centralizada da API
 * Garante que a URL base sempre termine com /api
 */

export function getApiBaseUrl(): string {
  const url = import.meta.env.VITE_API_URL || "http://localhost:3000/api";
  // Se não terminar com /api, adicionar
  return url.endsWith("/api") ? url : `${url.replace(/\/$/, "")}/api`;
}

export const API_BASE_URL = getApiBaseUrl();

